import FormikMobileField from "components/forms/formikFields/FormikMobileField";
import FormikSelectField from "components/forms/formikFields/FormikSelectField";
import { Field } from "formik";
import { Button, Col, Row } from "reactstrap";
import { InstituationphonesType } from "utils/Constants";
import { getOAuthUser } from "utils/UserHelper";

export const RenderInstituationPhoneFormFields = (props) => {
  const { index, values, remove, setFieldValue } = props;
  const oAuthUser = getOAuthUser();
  const regPhone = oAuthUser.mobileNo;

  const isDisabledCheck = (inputPhone, userRegPhone) => {
    if (inputPhone) {
      return inputPhone.replace(/ /g, "") === userRegPhone;
    }
    return false;
  };

  return (
    <Row className="institution-phone-field">
      <Col md={3} className="">
        <label className="">Type</label>
        <Field
          id={`phones[${index}].type`}
          name={`phones[${index}].type`}
          type="text"
          component={FormikSelectField}
          value={values.phones[index].type}
          inputprops={{
            name: `phones[${index}].type`,
            options: InstituationphonesType,
            keys: {
              id: "value",
              label: "label",
            },
          }}
        />
      </Col>
      <Col md={8} className="phone-number-field">
      <label className="">Phone Number</label>
        <Field
          id={`phones[${index}].value`}
          name={`phones[${index}].value`}
          type="text"
          component={FormikMobileField}
          placeholder="Enter number"
          value={values.phones[index].value}
        />
      </Col>
      <Col md={1} xs={6} className="contact-form-radio">
      <label className="d-xs-none">&nbsp;</label>
        <Button
          id="ripf_btn_del"
          color="danger"
          className="nexogic-del-btn"
          onClick={() => {
            const fullItem = values.phones.filter(
              (_, indexItem) => indexItem !== index
            );
            remove(index);
            setFieldValue(`phones`, fullItem);
          }}
          disabled={isDisabledCheck(values.phones[index].value, regPhone)}
        >
          <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.398438 5.77344L1.25857 12.1323C1.42602 13.3702 1.50975 13.9892 1.93372 14.3597C2.3577 14.7302 2.9823 14.7302 4.2315 14.7302H7.46922C8.71842 14.7302 9.34302 14.7302 9.76699 14.3597C10.191 13.9892 10.2747 13.3702 10.4421 12.1323L11.3023 5.77344" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.51562 3.04747V3.04747C3.51562 2.26721 3.51562 1.87708 3.65723 1.57473C3.80607 1.25693 4.06162 1.00138 4.37942 0.852541C4.68176 0.710938 5.0719 0.710938 5.85216 0.710938V0.710938C6.63243 0.710938 7.02256 0.710938 7.32491 0.852541C7.6427 1.00138 7.89825 1.25693 8.0471 1.57473C8.1887 1.87708 8.1887 2.26721 8.1887 3.04747V3.04747" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.3023 3.05469L0.398438 3.05469" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.89062 6.17188L4.28005 12.0132" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.79567 6.17188L7.40625 12.0132" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Button>
      </Col>
    </Row>
  );
};
